const pageName = 'pricelists';

export default pageName;


